import React from 'react';
import {
    SelectedDiv,
    SelectedCurrentLoc,
    Parked,
} from 'src/pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import BatchLocationCard from 'src/pages/scheduleSurgery/components/shipping/BatchLocationCard';
import NtCheckboxCheckedAndDisabled from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxCheckedAndDisabled';
import NtCheckboxwithTransferFailedWithDropdown from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxwithTransferFailedWithDropdown';
import NtCheckboxDropdownWithErroText from '../../../pages/scheduleSurgery/components/shipping/NonTissuecomponents/NtCheckboxDropdownWithErroText';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';

const CheckBoxTransfer = ({
    item,
    inventoryShipping,
    countryISOCode,
    handleLocationChange = () => {},
    checked = false,
    selectedLocation,
    allocatedData,
    isShowCheckBox,
    isMessageDisplay,
    isShowLabelEmpty,
    isShowDropDown,
}) => {
    const { t } = useTranslation();
    let batchLocations = useSelector((state) =>
        state.shippingBatchAllocation.batchAllocations.find(
            (batch) => batch.productCfn === (item?.cfn || item?.productCFN)
        )
    );
    const selectedBatchLocationTemplate = (option, props) => {
        if (option) {
            return option.id === 'Batch Not Found' ? (
                <SelectedDiv width={item?.isReservationSet && '261px'}>
                    <SelectedCurrentLoc
                        width={'auto'}
                        // width={option.isParked ? '80%' : '100%'}
                        // mbWidth={option.isParked ? '60%' : '100%'}
                    >
                        {t(
                            'scheduleSurgery.Shipping.ProductCard.batchNotFound'
                        )}
                    </SelectedCurrentLoc>
                </SelectedDiv>
            ) : (
                <SelectedDiv width={item?.isReservationSet && '261px'}>
                    <SelectedCurrentLoc
                        width={'auto'}
                        // width={option.isParked ? '80%' : '100%'}
                        // mbWidth={option.isParked ? '60%' : '100%'}
                    >
                        {option.currentLocationFormatted}
                    </SelectedCurrentLoc>
                    {option.isParked && !item?.isReservationSet && (
                        <Parked>
                            {t('equity.common.setsAndItems.parked')}
                        </Parked>
                    )}
                </SelectedDiv>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    const batchLocationTemplate = (option) => {
        return (
            <BatchLocationCard
                option={option}
                isReservationSet={item?.isReservationSet}
            />
        );
    };

    return (
        <>
            {item?.lineNumber != null || item?.lineNumber != undefined ? (
                item?.batchAllocation?.id && !inventoryShipping ? (
                    batchLocations?.batchAllocations
                        ?.filter((batch) =>
                            countryISOCode !== US_COUNTRY_CODE ? true : batch.isParked
                        )
                        .find(
                            (batch) => batch.id === item?.batchAllocation?.id
                        ) ? (
                        <NtCheckboxCheckedAndDisabled
                            label={t(
                                'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                            )}
                            batchLocations={batchLocations}
                            productKey={item.productKey}
                            nonTissueProduct={item}
                            isShowCheckBox={isShowCheckBox}
                            isMessageDisplay={isMessageDisplay}
                            isShowLabelEmpty={isShowLabelEmpty}
                            isShowSetLocation={false}
                        />
                    ) : (
                        <NtCheckboxwithTransferFailedWithDropdown
                            checkBoxClick={(event) => {
                                if (!inventoryShipping)
                                    handleLocationChange(
                                        item.productKey,
                                        !item.shippingRequirement
                                    );
                            }}
                            inventoryShipping={inventoryShipping}
                            AlertCircleOutline={AlertCircleOutline}
                            nonTissueProduct={item}
                            batchLocations={batchLocations}
                            selectedBatchLocationTemplate={
                                selectedBatchLocationTemplate
                            }
                            checked={checked}
                            batchLocationTemplate={batchLocationTemplate}
                            selectedLocation={selectedLocation}
                            handleLocationChange={handleLocationChange}
                            isShowCheckBox={isShowCheckBox}
                            isMessageDisplay={isMessageDisplay}
                            isShowLabelEmpty={isShowLabelEmpty}
                            isShowSetLocation={false}
                            isShowDropDown={isShowDropDown}
                        />
                    )
                ) : (
                    <NtCheckboxCheckedAndDisabled
                        label={t(
                            'scheduleSurgery.Shipping.ProductCard.TransferComplete'
                        )}
                        batchLocations={batchLocations}
                        productKey={item.productKey}
                        nonTissueProduct={item}
                        isShowCheckBox={isShowCheckBox}
                        isMessageDisplay={isMessageDisplay}
                        isShowLabelEmpty={isShowLabelEmpty}
                        isShowSetLocation={false}
                    />
                )
            ) : (
                <NtCheckboxDropdownWithErroText
                    isShowCheckBox={isShowCheckBox}
                    isMessageDisplay={isMessageDisplay}
                    isShowLabelEmpty={isShowLabelEmpty}
                    checked={checked}
                    checkBoxClick={(event) => {
                        if (!inventoryShipping)
                            handleLocationChange(
                                item.productKey,
                                !item.shippingRequirement
                            );
                    }}
                    inventoryShipping={inventoryShipping}
                    batchLocations={batchLocations}
                    selectedBatchLocationTemplate={
                        selectedBatchLocationTemplate
                    }
                    allocatedData={allocatedData}
                    batchLocationTemplate={batchLocationTemplate}
                    selectedLocation={selectedLocation}
                    handleLocationChange={handleLocationChange}
                    nonTissueProduct={item}
                    isShowSetLocation={false}
                    isShowDropDown={isShowDropDown}
                />
            )}

            {/*end transfer surgery check*/}
        </>
    );
};

export default CheckBoxTransfer;